<script>
import 'animate.css'
import { WOW } from 'wowjs'
export default {
  data() {
    return {
      list: [
        {
          title: '專屬優惠，<br>投放給對的人！',
          subTitle: 'Coupons',
          content: '<p>i寵訂的「發送優惠券」功能，為您找到最有價值的客戶，將行銷效益極大化，優惠券不再無的放矢，讓您的客戶都能變成回頭客。藉由報表數據行銷優惠成效一目瞭然。</p>',
          bg: require('@assets/images/basicplan/blob-1.svg'),
          img1: require('@assets/images/adminImgs/interface10@1.png'),
          // img2: require('@assets/images/adminImgs/intermediateplan_coupons.png')
        },
        {
          title: '線上付款',
          subTitle: 'Online Payment',
          content: '<p>接受線上付款。預約下單後，客戶會收到系統發送的付款通知簡訊。透過安全的第三方金流驗證機制，提供線上信用卡和ATM虛擬帳號付款，客戶即可提前完成付款確保有效預約，並且大大地減少未出席的狀況。</p>',
          bg: require('@assets/images/basicplan/blob-2.svg'),
          img1: require('@assets/images/adminImgs/interface11@1.png'),
          // img2: require('@assets/images/adminImgs/intermediateplan_payment@2x.png'),
        },
        // {
        //   title: '分店管理',
        //   subTitle: 'Branches',
        //   content: '<p>若您有多間分店，那麼多店管理功能就是必須的！可各自設定店家資訊，讓您的客戶快速選擇他們最便利的分店！系統行銷整合方案可設置2間分店，若欲增加更多分店，則另外提供加購。</p>',
        //   bg: require('@assets/images/basicplan/blob-3.svg'),
        //   img1: require('@assets/images/adminImgs/intermediateplan_branches.png'),
        //   // img2: require('@assets/images/adminImgs/intermediateplan_branches.png'),
        // },
      ]
    }
  },
  mounted() { 
    this.$nextTick(() => {  
      let wow = new WOW({
        live:false
      })
      wow.init()
    })
  }
}
</script>

<template>
  <div :class="$style.sectionFeatures">
    <!-- <img src="@assets/images/home/section7-image.png" alt="" class="sectionSecondary__img"> -->
    <div class="container section">
      <div 
        v-for="(item, $index) in list"
        :key="$index"
        class="row sectionFeatures__list text-xl-left text-center" 
        :class="{ 'flex-row-reverse': $index % 2 === 1 }"
      >
        <div class="col-xl-5 col-12 align-self-center">
          <div v-if="$index % 2 === 1" class="wow animate__animated animate__fadeInRight">
            <BaseSectionTitle 
              :title="item.title" 
              :sub-title="item.subTitle" 
              class="isStyleDecoration mx-xl-0 isxlCenter mx-auto"
            />
            <div class="sectionFeatures__content" v-html="item.content">

            </div>
          </div>
          <div v-else class="wow animate__animated animate__fadeInLeft">
            <BaseSectionTitle 
              :title="item.title" 
              :sub-title="item.subTitle" 
              class="isStyleDecoration mx-xl-0 isxlCenter mx-auto"
            />
            <div class="sectionFeatures__content" v-html="item.content">

            </div>
          </div>
        </div>
        <div class="col-xl-7 col-12 sectionFeatures__img">
          <div
            v-if="$index % 2 === 1" 
            :class="`sectionFeatures__img--item item${$index}`"
            class="mt-xl-0 mt-5 wow animate__animated animate__fadeInLeft left"
          >
            <img
              class="img" 
              :src="item.img1"
              alt=""
            >
          </div>
          <div
            v-else
            :class="`sectionFeatures__img--item item${$index}`"
            class="mt-xl-0 mt-5 wow animate__animated animate__fadeInRight right"
          >
            <img
              class="img" 
              :src="item.img1"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.sectionFeatures {
  position: relative;
  overflow: hidden;
  @include max-xl {
    margin-top: -70px;
  }
  @include max-lg {
    margin-top: 0;
    padding-top: 70px;
  }
  &:before {
    content:'';
    position: absolute;
    background-image: url('@assets/images/intermediateplan/paw.svg');
    background-repeat: no-repeat;
    background-size: cover;
    width: 10%;
    padding-bottom: 12%;
    bottom: 24%;
    right: 0;
    @include max-lg {
      display: none;
    }
  }
  :global {
    .sectionFeatures {
      &__img {
        // position: relative;
        // padding-bottom: 34%;
        // // @include max-md {
        // //   padding-bottom: 78%;
        // // }
        // .img {
        //   position: absolute;
        //   top: 0;
        //   left: 0;
        //   right: 0;
        //   bottom: 0;
        //   // background: #bed6da;
        //   background-size: cover;
        //   background-repeat: no-repeat;
        //   background-position: center;
        // }
      }
      &__content {
        color: $color-text-2;
        @include max-md {
          font-size: 14px;
        }
      }
      &__img {

        &--item {
          position: relative; 
          &:before {
          content: '';
          position: absolute;
          background-size: cover;
          background-repeat: no-repeat;
          }
          &.right {
            padding-left: 70px;
            @include max-xl {
              padding-left: 0;
            }
          }
          &.left {
            padding-right: 70px;
            @include max-xl {
              padding-right: 0;
            }
          }
          
          &.item0 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-1.svg');
              width: 77%;
              padding-bottom: 72%;
              top: -7%;
              right: -10%;
              
            }
          }
          &.item1 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-2.svg');
              width: 72%;
              padding-bottom: 64%;
              left: -15%;
              bottom: -30%;
            }
          }
          &.item2 {
            &:before {
              background-image: url('~@assets/images/basicplan/shutterstock_551338465.svg');
              width: 72%;
              padding-bottom: 64%;
              right: -20%;
              top: -34%;
            }
          }
          &.item3 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-3.svg');
              width: 45%;
              padding-bottom: 46%;
              left: -16%;
              top: -17%;
            }
          }
          &.item4 {
            &:before {
              background-image: url('~@assets/images/basicplan/blob-5.svg');
              width: 60%;
              padding-bottom: 65%;
              right: -16%;
              top: -30%;
            }
          }
        }
        
        .img {
          position: relative;
          z-index: 3;
          box-shadow: 0px 5px 20px rgba(40, 45, 78, 0.2);
          border-radius: 10px;
        }
      }
      &__list {
        &:not(:first-child) {
          margin-top: 230px;
          @include max-xl {
            margin-top: 116px;
          }
        }
      }
    }
    
  }
}
</style>